export default "__VITE_ASSET__687ce39b__"